import { UserLayout } from "@/components/layouts/user-layout"
import { LocaleSelector } from "@/components/features/profiles/locale-selector"
import { TimeZoneSelector } from "@/components/features/profiles/time-zone-selector"
import { ScreenHeader } from "@/components/ui/headers"
import { TimeZoneOption } from "@/lib/time-zone"
import { t } from "@/lib/i18n"

type Props = {
  timeZone: string
  timezones: TimeZoneOption[]
}

/**
 * Language and time zone, back on a screen of their own. They lived inline on
 * /profile while that screen had nothing else to hold; now it is the hub, and
 * two selectors ahead of the navigation would bury it.
 *
 * Open to guests. Their language is as much theirs to set as anyone's, and the
 * controls were already reachable to them before this move.
 */
export default function UserProfilesSettings({ timeZone, timezones }: Props) {
  return (
    <UserLayout>
      <div className="text-foreground" data-testid="profile-settings-view">
        <ScreenHeader title={t("ui.react.pages.user.profiles.settings.title")} />

        <div className="mx-auto w-full max-w-lg space-y-6 px-4 pb-6 pt-2">
          <LocaleSelector />
          <TimeZoneSelector timeZone={timeZone} timezones={timezones} />
        </div>
      </div>
    </UserLayout>
  )
}
